
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Hidden from '@/components/hidden/index.vue'
  import MainHeader from '@/components/header/index.vue'
  import MainFooter from '@/components/footer/index.vue'
  import Pushes from '@/components/pushes/index.vue'
  import { isIPad, isMobile } from '@/helpers/variables'

  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'app',
    data() {
      return {
        isShowSocials: !(this as any).$route.matched.some((route: any) => ['buy-flow', 'profile'].indexOf(route.name) !== -1),
        windowSize: window.innerWidth,
        isCountrySelected: localStorage.getItem('country') !== null,
      }
    },
    components: {
      Hidden,
      MainHeader,
      MainFooter,
      Pushes
    },
    watch: {
      $route() {
        this.setCanonical()
        this.setAlternate()
        // Згорнуто на кошику / оформленні / кабінеті, розгорнуто на решті сторінок
        this.isShowSocials = !this.collapseSocials
      },
    },
    computed: {
      ...mapGetters({
        isAuthenticated: `auth/isAuthenticated`,
        variables: `setting/variables`,
        globalLoader: 'system/globalLoader',
        showPushes: 'pushes/showPushes',
      }),
      // Сторінки, де віджет соцмереж має бути згорнутим за замовчуванням:
      // кошик, оформлення замовлення та особистий кабінет
      collapseSocials() {
        return (this as any).$route.matched.some((route: any) => ['buy-flow', 'profile'].indexOf(route.name) !== -1)
      },
      // isFooterInViewport() {
      //     const pageHeight = document.documentElement.clientHeight;
      //     const footer = document.querySelector(".footer");
      //     const footerTop = footer.getBoundingClientRect().top;
      //     return footerTop < pageHeight;
      // }
    },
    created() {
      if (this.isAuthenticated) {
        this.fetchUser()
        this.getFavorites()
      }
      this.getVariables()
      this.getPages()
      this.checkSelectedCountry()
      this.setCanonical()
      this.setAlternate()
    },
    mounted() {
      if (!isMobile.any()) {
        document.querySelector('body')?.classList.add('hover')
      }
      if (!isIPad.iOS()) {
        document.querySelector('body')?.classList.add('iPad')
      }
    },
    methods: {
      ...mapMutations({
        changeFeedbackModal: 'popups/CHANGE_FEEDBACK_MODAL',
        changeCountryModal: 'popups/CHANGE_COUNTRY_MODAL',
        showGlobalLoader: 'system/SHOW_GLOBAL_LOADER',
      }),
      ...mapActions({
        fetchUser: 'profile/FETCH_USER_DATA',
        getFavorites: 'favorites/GET_FAVORITES_LIST',
        getVariables: 'setting/GET_VARIABLES',
        getPages: 'pages/FETCH_PAGES',
      }),
      setCanonical() {
        const link = window.location.href.split('?')[0]
        const canonical = document.querySelector('link[rel="canonical"]')
        if (canonical) {
          canonical.setAttribute('href', link)
        }
      },
      setAlternate() {
        const link = window.location.href.split('?')[0]
        const hreflangs = document.querySelectorAll('link[rel="alternate"][hreflang]')
        const url = new URL(link)
        const pathWithoutLang = url.pathname.replace(/^\/(cz|en|ru|bg|da|de|el|es|et|fi|fr|ga|hr|hu|it|lb|lt|lv|mt|nl|pl|pt|ro|sk|sl|sv|tr)/, '')

        const hreflangToPrefix: { [key: string]: string } = { cs: 'cz' }

        hreflangs.forEach((hreflang) => {
          const lang = hreflang.getAttribute('hreflang')
          if (!lang) return
          if (lang === 'x-default') {
            hreflang.setAttribute('href', `${url.origin}/cz${pathWithoutLang}`)
          } else {
            const prefix = hreflangToPrefix[lang] || lang
            hreflang.setAttribute('href', `${url.origin}/${prefix}${pathWithoutLang}`)
          }
        })
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      },
      showSocials() {
        this.isShowSocials = !this.isShowSocials
      },
      openFeedbackModal() {
        this.changeFeedbackModal({ status: true })
      },
      openCountryModal() {
        this.changeCountryModal({ status: true })
      },
      checkSelectedCountry() {
        const selectedCountry = localStorage.getItem('country')
        setTimeout(() => {
          if (!selectedCountry) {
            this.openCountryModal()
          }
        }, 1000)
      },
    },
  })
